import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

const hotKeywords = ["搞笑合集", "纪录片", "现场音乐", "综艺名场面", "美食教学", "篮球集锦"];

export default function SearchBand() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  const submit = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  return (
    <section className="w-full px-4 md:px-6">
      <div className="w-full rounded-lg bg-primary-500 px-5 py-8 md:px-10 md:py-10">
        <div className="flex flex-col lg:flex-row lg:items-center gap-5 lg:gap-10">
          <div className="lg:w-2/5">
            <h2 className="font-heading text-xl md:text-2xl font-extrabold text-background-50">
              想看什么，直接搜
            </h2>
            <p className="mt-2 text-sm text-primary-100">
              输入关键词，快速找到标题或简介匹配的免费视频
            </p>
          </div>
          <div className="lg:w-3/5">
            <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2">
              <div className="relative flex-1">
                <span className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-foreground-400">
                  <i className="ri-search-line text-base" />
                </span>
                <input
                  type="text"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索视频标题或简介"
                  className="w-full h-12 pl-11 pr-4 text-sm bg-background-50 border border-transparent rounded-md text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-accent-400"
                />
              </div>
              <button
                type="submit"
                className="h-12 px-7 rounded-md bg-secondary-900 text-background-50 text-sm font-semibold hover:bg-secondary-950 transition-colors whitespace-nowrap cursor-pointer"
              >
                搜索视频
              </button>
            </form>
            <div className="mt-3 flex flex-wrap items-center gap-2">
              <span className="text-xs text-primary-100">热门搜索：</span>
              {hotKeywords.map((k) => (
                <button
                  key={k}
                  type="button"
                  onClick={() => navigate(`/search?q=${encodeURIComponent(k)}`)}
                  className="px-2.5 py-1 text-xs rounded-full bg-background-50/20 text-background-50 hover:bg-background-50/30 transition-colors cursor-pointer"
                >
                  {k}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}